export type globalPerPagePayload = {
  pageName: string;
  environment: string;
  itemsPerPage: number;
};

const UPDATE = 'UPDATE_PERPAGE';
export type GlobalPerPageReducerAction = {
  type: string;
  payload: globalPerPagePayload;
};


const initialState = [];

export const globalPerPageLocation = 'globalPerPage';
export const globalPerPageInitializer = (initialValue = initialState) =>
  JSON.parse(localStorage.getItem(globalPerPageLocation)) || initialValue;

export const globalPerPageReducer = (state: globalPerPagePayload[], action: GlobalPerPageReducerAction) => {
    switch (action.type) {
      case UPDATE:
        const newState = state.find(
          item =>
            item.pageName === action.payload.pageName &&
            item.environment === action.payload.environment
        )
          ? state.map(item => {
              return item.pageName === action.payload.pageName
                ? {
                    environment: action.payload.environment,
                    itemsPerPage: action.payload.itemsPerPage,
                    pageName: action.payload.pageName
                  }
                : item;
            })
          : [...state, { ...action.payload }];
        return newState;
  
      default:
        return state;
    }
  };

  export const updateGlobalPerPage = (item: globalPerPagePayload) => ({
    type: UPDATE,
    payload: item
  });
  